import { zVehicleManufacturerCommonSchema } from "./vehicleManufacturer.common";
// Доменная схема для VehicleManufacturer (может быть расширена связанными данными)
export const zVehicleManufacturerSchemaDom = zVehicleManufacturerCommonSchema;
export const zVehicleManufacturerSchemaCreateDom = zVehicleManufacturerSchemaDom.omit({
    id: true,
});
